import { Box, Grid } from "@mui/material";
import dynamic from "next/dynamic";

import FullScreenImageDisplay from "./FullScreenImageDisplay";
import { useFullScreenImage } from "./useFullScreenImage";

import { FormZeffyLoader } from "@/forms-design-system/FormZeffyLoader";

// eslint-disable-next-line react/display-name
const Image = dynamic(() => import("../../Image/Image"), { loading: () => <FormZeffyLoader /> });

interface MultipleImageDisplayProps {
  purchasedNumber: number;
  photoUrls: string[];
  title: string;
}

const TicketingV2MobileMultipleImageDisplay = ({ purchasedNumber, photoUrls, title }: MultipleImageDisplayProps) => {
  const size = 120;

  const { displayedImageIndex, isFullScreen, goLeft, goRight, closeFullScreen, openFullScreen, setSelectedIndex } =
    useFullScreenImage();

  return (
    <Grid item>
      <FullScreenImageDisplay
        photoUrls={photoUrls}
        title={title}
        displayedImageIndex={displayedImageIndex}
        isFullScreen={isFullScreen}
        goLeft={goLeft}
        goRight={goRight}
        closeFullScreen={closeFullScreen}
        setSelectedIndex={setSelectedIndex}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: purchasedNumber > 0 ? "100%" : "110%",
          maxWidth: purchasedNumber > 0 ? "100%" : "110%",
          overflowX: "auto",
          overflowY: "hidden",
          flexWrap: "nowrap",
          "-webkit-overflow-scrolling": "touch",
          scrollSnapType: "x mandatory",
          margin: "0 auto",
        }}
      >
        {photoUrls.map((photoUrl, index) => (
          <Box
            key={index}
            sx={{
              width: size,
              height: size,
              flex: "0 0 auto",
              scrollSnapAlign: "start",
              cursor: "zoom-in",
              marginRight: index === photoUrls.length - 1 && purchasedNumber === 0 ? 3.5 : 1,
            }}
            onClick={openFullScreen}
          >
            <Image
              nextImage
              src={photoUrl}
              sx={{
                borderRadius: 8,
              }}
              alt={title ? `${title} item` : "item"}
              width={size}
              height={size}
              objectFit="cover"
              data-test="rate-image"
              resolution={size * 2}
            />
          </Box>
        ))}
      </Box>
    </Grid>
  );
};

export default TicketingV2MobileMultipleImageDisplay;
